import * as React from "react";
import glamorous from "glamorous";
import Header from "../Header";
import Footer from "../Footer";
import { Segment } from "semantic-ui-react";

export interface PageProps {}

const Page: React.SFC<PageProps> = props => (
	<>
		<Header />
		<Segment vertical style={{ flexGrow: 1, flexBasis: "auto" }}>
			{props.children}
		</Segment>
		<Footer />
	</>
);

export default Page;



// WEBPACK FOOTER //
// ./src/components/Page/Page.tsx